import React from 'react';
import { Link } from 'react-router-dom';
import { INSTAGRAM_URL } from '../constants';
import { conditions } from '../data/conditions';

function SiteFooter() {
  return (
    <footer className="site-footer pt-5 pb-3">
      <div className="container">
        <div className="row g-4">
          <div className="col-md-6 col-lg-4">
            <h3 className="h5 fw-bold">About YH Physio &amp; Performance</h3>
            <p className="mb-0">
              Expert musculoskeletal and sports physiotherapy in Bradford, serving patients across
              West Yorkshire and beyond.
            </p>
          </div>
          <div className="col-md-6 col-lg-4">
            <h3 className="h5 fw-bold">Quick Links</h3>
            <ul className="list-unstyled mb-0 footer-links">
              <li>
                <Link to="/physiotherapy-bradford">Home</Link>
              </li>
              <li>
                <Link to="/how-it-works">How It Works</Link>
              </li>
              <li>
                <Link to="/about-us">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/conditions">Conditions We Treat</Link>
              </li>
              <li>
                <Link to="/testimonials">Testimonials</Link>
              </li>
              <li>
                <Link to="/policies">Policies</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
            </ul>
          </div>
          <div className="col-lg-4">
            <h3 className="h5 fw-bold">Conditions We Treat</h3>
            <ul className="list-unstyled mb-4 footer-links footer-links-columns">
              {conditions.map((condition) => (
                <li key={condition.slug}>
                  <Link to={condition.path}>{condition.name}</Link>
                </li>
              ))}
            </ul>
            <h3 className="h5 fw-bold">Get In Touch</h3>
            <p className="mb-1">07947781979</p>
            <p className="mb-1">info@yhphysio.com</p>
            <p className="mb-1">
              Heaton Tennis &amp; Squash Club, Garth Barn Close, Highgate, Heaton, Bradford, BD9 5PH
            </p>
            <p className="mb-1">Free parking available on site.</p>
            <p className="mb-4">Physio room based upstairs.</p>
            <a
              className="instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              aria-label="Visit our Instagram profile"
              title="Instagram"
            >
              <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5Zm8.88 1.56a1.06 1.06 0 1 1 0 2.12 1.06 1.06 0 0 1 0-2.12ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
              </svg>
              <span>Instagram</span>
            </a>
          </div>
        </div>
        <hr className="my-4 border-light-subtle" />
        <p className="small mb-1 text-center">
          Copyright 2026 YH Physio and Performance. All rights reserved.
        </p>
        <p className="small mb-1 text-center">
          YH Physio &amp; Performance is a trading name of Y Haq Healthcare Ltd.
        </p>
        <p className="small mb-0 text-center">
          Based in Bradford, West Yorkshire, serving Shipley, Bingley, Saltaire, Ilkley, Leeds, and
          surrounding areas.
        </p>
      </div>
    </footer>
  );
}

export default SiteFooter;
